/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

//
import { arr_inArray, elementHasClassName } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { getFromSession } from './session-util.js';
import { scrollElementIntoView } from './dialog-util.js';
import { jQuery } from '../other/jquery-hooked.js';

import { Lightbox } from './lightbox.js';
import { MVSearch } from './search.js';
import { mjWidgetOverlayEditor } from './widget-overlay-editor.js';


export let MMediaViewsKbdCtrl = function($) {

	var m_result_root = null,
		m_rv_selector1_not_del = '.media.undel,.category',
		m_rv_combined_m_selector_not_del = '> .media.undel > .thumbnail',
		m_rv_combined_c_selector = '> .category > .cthumbnail',
		m_rv_combined_selector_not_del = '> .media.undel > .thumbnail,> .category > .cthumbnail',
		// m_rv_combined_selector_not_del_selected = '> .media.undel > .ui-selected.thumbnail,> .category > .ui-selected.cthumbnail',
		m_rv_selector2 = '.thumbnail,.cthumbnail';

	var m_result_view_widget = null;
	var m_open_action = null;
	var m_toggle_ctx_toolbar_action = null;


	function _handleKeydown( evt ) {
		var key = evt.which;
		var $body = $(document.body);

		//if( key==9 ) console.log( ['_handleKeydown',evt] );

		if( $body.children('#page-blocking-overlay,#progress,#mvl-values,div.ui-dialog,div.ui-widget-overlay,div.colorpicker,span.select2-container--open').is(':visible') ) {
			// ignore any keypresses if:
			// - a dialog is open
			// - or colorpicker is visible
			// - or a select2 container is open
			// - or some other kind of overlay is visible
			//console.log( ['_handleKeydown (1) IGNORED',evt] );
			return true;
		} else if( $body.find('> #page > #media-ctx-menu').is(':visible') ) {
			// ignore any keypresses if:
			// - or the context menu is visible
			// - or the context toolbar is visible
			// except on CTRL+A (select all)
			if( ( evt.ctrlKey || evt.metaKey ) && !evt.shiftKey && key==65 ) {
				return _handleSelectAll(evt);
			}
			return true;
		} else if( $body.children('#ui-datepicker-div').is(':visible') || $body.find('span.select2-container--focus').is(':visible') ) {
			// ignore keypresses if:
			// - datepicker is visible
			// - or a select2 container is focused
			// except on TAB key
			if( key==9 ) {
				//console.log( ['_handleKeydown (3) -> calling _handleTABKey',evt,key] );
				return _handleTABKey(evt);
			}
			//console.log( ['_handleKeydown (3) IGNORED',evt,key] );
			return true;
		} else if( window.MVPageDebug && window.MVPageDebug.isVisible() ) {
			// ignore keypresses if:
			// - #dprint overlay is visible
			return true;
		} else if( mjWidgetOverlayEditor.isOpen() ) {
			// ignore keypresses if:
			// - #mj-widget-overlay
			return true;
		}

		if( key==9 ) {
			// TAB key
			return _handleTABKey(evt);
		} else if( MVSearch.hasFocus() ) {
			// ignore keypresses in search string or options
			return true;
		} else if( $('.tree-search-box').is(':focus') ) {
			// ignore keypresses in tree-search inputs
			return true;
		}

		return _unobstructed_handleKeydown(evt);
	}


	function _unobstructed_handleKeydown( evt, customSelectionChanged ) {
		var key = evt.which;
		if( key==32 || key==77 || key==13 || ( key>=37 && key<=40 ) ) {
			// ignore alt+meta+(*) combinations (these may be used for tab navigation on OSX...)
			if( evt.altKey && evt.metaKey ) return true;

			// UP,RIGHT,DOWN,LEFT, SPACE,M,ENTER in result or lightbox view
			var navigate_in_lb = _isLightboxVisible() && ( _get_lb_nodes().filter('.ui-selected').length>0 || _get_rv_nodes1().length==0 );
			return navigate_in_lb ? _keydownInLightbox(evt,customSelectionChanged) : _keydownInResultView(evt,customSelectionChanged);

		} else if( ( evt.ctrlKey || evt.metaKey ) && !evt.shiftKey && key==65 ) {
			return _handleSelectAll(evt,customSelectionChanged);
		} else if( key>=33 && key<=36 ) {
			var rst = m_result_root.scrollTop(),
				page_delta = m_result_root.height();
			switch( key ) {
			case 33:	// PgUp
				m_result_root.scrollTop( Math.max(0,rst-page_delta) );
				break;
			case 34:	// PgDown
				m_result_root.scrollTop( rst+page_delta );
				break;
			case 35:	// End
				m_result_root.scrollTop( m_result_root.prop('scrollHeight') );
				break;
			case 36:	// Home/Pos1
				m_result_root.scrollTop( 0 );
				break;
			}
			return false;
		}
	}


	function _doFocusOrSelect( node ) {
		var tn = node.prop('tagName');
		if( tn==='TEXTAREA' || ( tn==='INPUT' && node.prop('type')==='text' ) ) node.select();
		else node.focus();
	}

	function _isLightboxVisible() {
		return $('#media-lightbox-small').css('display')!='none';
	}

	function _handleTABKey( evt ) {
		var lb_visible = _isLightboxVisible();
		var lb_nodes = lb_visible ? _get_lb_nodes() : null;
		var rv_nodes = _get_rv_nodes1();
		var cur_area = rv_nodes.length>0 ? 'rv' : 'search';

		var areas = [
			'search'
		];
		if( lb_visible && lb_nodes.length>0 ) areas.push('lb');
		if( rv_nodes.length>0 ) areas.push('rv');

		var all_sopts_nodes = null;
		var focused_snode = MVSearch.getFocusedElementNode();
		if( focused_snode ) {
			all_sopts_nodes = MVSearch.getFocusableNodes();
			// some search-related element is focused --> enable tabbing through all these option elements (..enabled & visible)
			var asnl = all_sopts_nodes.length;
			if( asnl > 1 ) {
				for( var i=0; i<asnl; ++i ) {
					if( all_sopts_nodes[i]===focused_snode ) {		// IDENTITY compare
					//if( all_sopts_nodes.eq(i).is(':focus') ) {
						if( evt.shiftKey ) {
							if( i-1 >= 0 ) {
								// focus previous search option ...
								_doFocusOrSelect( all_sopts_nodes.eq(i-1) );
								return false;
							}
						} else if( i+1 < asnl ) {
							// focus next search option ...
							_doFocusOrSelect( all_sopts_nodes.eq(i+1) );
							return false;
						}
					}
				}
			}
			cur_area = 'search';
		} else if( lb_visible && lb_nodes.length>0 ) {
			// lightbox is focused if some lb node is selected or if result view is completely empty
			if( lb_nodes.filter('.ui-selected').length>0 || rv_nodes.length==0 ) cur_area = 'lb';
		} else {
			// otherwise: expect result view to be focused
		}
		// compute idx of current area
		var cur_area_idx = arr_inArray(cur_area,areas);
		if( cur_area_idx<0 ) cur_area_idx = 0; // should never happen anyway
		// backward (shift key) or forward (no shift) in tab areas ..
		var nxt_area_idx = ( evt.shiftKey ? (cur_area_idx+areas.length-1) : (cur_area_idx+1) ) % areas.length;
		// un-focus cur area
		switch( areas[cur_area_idx] ) {
		case 'search':	if( focused_snode ) focused_snode.blur(); break;		//all_sopts_nodes.filter(':focus').blur();						break;
		case 'lb':		lb_nodes.filter('.ui-selected').removeClass('ui-selected');		break;
		case 'rv':		rv_nodes.filter('.ui-selected').removeClass('ui-selected');		break;
		}
		// focus new area
		switch( areas[nxt_area_idx] ) {
		case 'search':
			//if( all_sopts_nodes===null ) all_sopts_nodes = MVSearch.getFocusableNodes();
			// NOTE: get fresh node list ..
			all_sopts_nodes = MVSearch.getFocusableNodes();
			_doFocusOrSelect( evt.shiftKey ? all_sopts_nodes.last() : all_sopts_nodes.first() );
			break;
		case 'lb':		_defaultSelectFirstNode(lb_nodes,null);				break;
		case 'rv':		_defaultSelectFirstNode(rv_nodes,m_result_root);	break;
		}
		if( areas[cur_area_idx]==='lb' || areas[nxt_area_idx]==='lb' ) Lightbox.selectionChanged(evt,'MMediaViewsKbdCtrl::_handleTABKey');//areas[nxt_area_idx]==='lb');
		if( rv_nodes.length>0 ) m_result_view_widget.selectionChanged(evt,true);
		return false;
	}

	function _get_lb_nodes() {
		return $('.lb-item.undel',document.getElementById('lb-result'));
	}
	function _get_rv_nodes1() {
		return m_result_root.find(m_rv_combined_selector_not_del);
	}
	function _get_rv_nodes( mode ) {
		if( mode==='categories' )							return m_result_root.find(m_rv_combined_c_selector);
		else if( mode==='media' || mode==='media-all' )		return m_result_root.find(m_rv_combined_m_selector_not_del);
		return m_result_root.find(m_rv_combined_selector_not_del);
	}

	function _xnodes2ynodes( nodes ) {
		if( nodes.length===1 ) {
			// optimization for common case:
			return nodes.closest( elementHasClassName(nodes[0],'cthumbnail') ? '.category' : '.media' );
		}
		return nodes.closest('.category,.media');
	}

	function _defaultSelectFirstNode( all_nodes, container_node ) {
		if( all_nodes.length!==0 && all_nodes.filter('.ui-selected').length===0 ) {
			var first_node = all_nodes.first().addClass('ui-selected');
			// also scroll node into view
			if( container_node!==null ) scrollElementIntoView( _xnodes2ynodes(first_node), container_node, 0, 3 );
		}
	}

	function _selectAndOrGetSelectedNodeState( all_nodes ) {
		var sel_nodes = all_nodes.filter('.ui-selected');
		if( sel_nodes.length==0 ) {
			// auto-select first node
			return [ false, all_nodes.first().addClass('ui-selected') ];
		}
		// just return currently selected nodes
		return [ true, sel_nodes ];
	}

	function _selectAndOrGetSelectedNodeState_rv() {
		//var sel_nodes = m_result_root.children('.media.undel,.category').children('.ui-selected');
		var sel_nodes = m_result_root.find('.media.undel div.ui-selected, .category div.ui-selected');
		if( sel_nodes.length===0 ) {
			// auto-select first node
			return [ false, m_result_root.find(m_rv_combined_selector_not_del).first().addClass('ui-selected') ];
		}
		// return currently selected nodes
		return [ true, sel_nodes ];
	}

	function _keydownInLightbox( evt, customSelectionChanged ) {
		var tmp = _selectAndOrGetSelectedNodeState(_get_lb_nodes());
		var has_sel = tmp[0];
		var sel_nodes = tmp[1];

		var ns_node = null;
		var tmp_node;
		var tmp_candidates;
		var shiftMode = evt.shiftKey;

		if( has_sel ) {
			// lightbox view: left=up=prev, right=down=next
			switch( evt.which ) {
			case 37: // left
				tmp_node = sel_nodes.first();
				ns_node = tmp_node.prevAll('.lb-item.undel:not(.ui-selected)').first();
				if( !shiftMode && ns_node.length===0 ) {
					if( $('#lb-less').is(':visible') ) {
						Lightbox.less( function() {
							_get_lb_nodes().last().addClass('ui-selected');
							if( customSelectionChanged ) customSelectionChanged();
							else Lightbox.selectionChanged(evt,'MMediaViewsKbdCtrl::_keydownInLightbox 37');
						} );
						return false;
					}
					ns_node = tmp_node;

				}
				break;
			case 39: // right
				tmp_node = sel_nodes.last();
				ns_node = tmp_node.nextAll('.lb-item.undel:not(.ui-selected)').first();
				if( !shiftMode && ns_node.length===0 ) {
					if( $('#lb-more').is(':visible') ) {
						Lightbox.more( function() {
							_get_lb_nodes().first().addClass('ui-selected');
							if( customSelectionChanged ) customSelectionChanged();
							else Lightbox.selectionChanged(evt,'MMediaViewsKbdCtrl::_keydownInLightbox 39');
						} );
						return false;
					}
					ns_node = tmp_node;

				}
				break;
			case 38: // up
				tmp_node = sel_nodes.first();
				tmp_candidates = tmp_node.prevAll('.lb-item.undel');
				ns_node = tmp_candidates.length===0 ? tmp_node : tmp_candidates.last();
				if( !shiftMode && tmp_candidates.length===0 ) {
					if( $('#lb-less').is(':visible') ) {
						Lightbox.less( function() {
							_get_lb_nodes().first().addClass('ui-selected');
							if( customSelectionChanged ) customSelectionChanged();
							else Lightbox.selectionChanged(evt,'MMediaViewsKbdCtrl::_keydownInLightbox 38');
						} );
						return false;
					}
				}
				if( shiftMode && ns_node.length && tmp_candidates.length ) tmp_candidates.not('.ui-selected').addClass('ui-selected');
				break;
			case 40: // down
				tmp_node = sel_nodes.last();
				tmp_candidates = tmp_node.nextAll('.lb-item.undel');
				ns_node = tmp_candidates.length===0 ? tmp_node : tmp_candidates.last();
				if( !shiftMode && tmp_candidates.length===0 ) {
					if( $('#lb-more').is(':visible') ) {
						Lightbox.more( function() {
							_get_lb_nodes().last().addClass('ui-selected');
							if( customSelectionChanged ) customSelectionChanged();
							else Lightbox.selectionChanged(evt,'MMediaViewsKbdCtrl::_keydownInLightbox 40');
						} );
						return false;
					}
				}
				if( shiftMode && ns_node.length && tmp_candidates.length ) tmp_candidates.not('.ui-selected').addClass('ui-selected');
				break;
			case 32: // space
			case 77: // M
			case 13: // enter
				window.setImmediate( function() {
					if( customSelectionChanged ) customSelectionChanged();
					else Lightbox.selectionChanged(evt,'MMediaViewsKbdCtrl::_keydownInLightbox '+(evt.which||'unknown'));
					if( sel_nodes && sel_nodes.length ) {
						if( evt.which==13 ) m_open_action();
						else m_toggle_ctx_toolbar_action();
					}
				} );
				return false;
			}
		}
		// update selected states
		if( !shiftMode ) sel_nodes.filter('.ui-selected').removeClass('ui-selected');
		if( ns_node && ns_node.length ) ns_node.addClass('ui-selected');

		window.setImmediate( function() {
			// update lightbox selection ...
			if( customSelectionChanged ) customSelectionChanged();
			else Lightbox.selectionChanged(evt,'MMediaViewsKbdCtrl::_keydownInLightbox other');
		} );
		return false;
	}

	function _fri_regular_up( noffs, roffs ) {
		return noffs.top < roffs.top && noffs.left<=roffs.left;
	}
	function _fri_regular_down( noffs, roffs ) {
		return noffs.top > roffs.top && noffs.left>=roffs.left;
	}
	function _fri_irregular_up(noffs,roffs,nw,rw) {
		return noffs.top < roffs.top
			? ( noffs.left == roffs.left
				? 1
				: ( noffs.left < roffs.left
					? ( noffs.left+nw-roffs.left > roffs.left+rw-(noffs.left+nw)
						? 1
						: -1 )
					: 0 ) )
			: 0;
	}
	function _fri_irregular_down(noffs,roffs,nw,rw) {
		return noffs.top > roffs.top
			? ( noffs.left == roffs.left
				? 1
				: ( noffs.left < roffs.left && noffs.left+nw >= roffs.left+rw
					? 1
					: ( noffs.left > roffs.left
						? ( roffs.left+rw-noffs.left > noffs.left-roffs.left
							? 1
							: -1 )
						: 0 ) ) )
			: 0;
	}

	function _find_result_item( evt, customSelectionChanged, sel_nodes, shiftMode, backwards, condition, track_widths ) {
		var result = { ns_node:null, tmp_candidates:[], more_triggered:false },
			ref_node = backwards ? sel_nodes.first() : sel_nodes.last(),
			ref_node_offs = ref_node.offset(),
			ref_node_width = track_widths ? (ref_node.width()||0) : 0,
			prev_node = _xnodes2ynodes(ref_node),
			//curr_node,
			i, $c, $prev_c, coffs, candidates_row_top=null, cr;

		var check_nodes = backwards
			? prev_node.prevAll(m_rv_selector1_not_del)
			: prev_node.nextAll(m_rv_selector1_not_del);

		var curr_node = prev_node;
		var il = check_nodes.length + 1;
		check_nodes = null; // not required anymore..

		for( i=0; i<il; ++i ) {	// just an upper limit of iterations to do here
			if( curr_node.length===0 ) {
				curr_node = prev_node;
				$c = curr_node.children(m_rv_selector2);
				if( $c.length>0 ) result.tmp_candidates.push($c[0]);
				result.ns_node = $c;
				if( !backwards ) {
					var elem;
					if( (elem=prev_node.nextAll('div.more-actions')).length>0 ) {
						result.more_triggered = true;
						window.setImmediate( function() {
							elem.children('div.more').trigger('click',function(success) {
								if( success ) _keydownInResultView(evt,customSelectionChanged);
							} );
						} );
						return result;
					}
				}
				break;
			}
			$c = curr_node.children(m_rv_selector2);
			coffs = $c.offset() || {top:0,left:0};
			if( candidates_row_top===null && ( backwards ? coffs.top < ref_node_offs.top : coffs.top > ref_node_offs.top ) ) {
				// this is the top offset of the row of our candidates
				candidates_row_top = coffs.top;
			}
			if( candidates_row_top!==null && ( backwards ? coffs.top < candidates_row_top : coffs.top > candidates_row_top ) ) {
				// skip candidates in further rows
				break;
			}
			if( shiftMode && $c.hasClass('cthumbnail') ) break;
			if( $c.length>0 ) result.tmp_candidates.push($c[0]);
			//if( !($c.width()||0) ) console.log( ['zero width node: ',$c,sel_nodes] );
			cr = track_widths ? condition(coffs,ref_node_offs,$c.width()||0,ref_node_width) : condition(coffs,ref_node_offs);
			if( cr===true || cr===1 ) {
				// use current node
				result.ns_node = $c;
				break;
			} else if( cr===-1 ) {
				if( i>0 && candidates_row_top!==null && $prev_c.offset().top===candidates_row_top ) {
					// use previous node
					result.tmp_candidates.pop();
					result.ns_node = $prev_c;
				} else {
					// use current node
					result.ns_node = $c;
				}
				break;
			}
			prev_node = curr_node;
			for(;;) {
				curr_node = backwards ? curr_node.prev() : curr_node.next();
				if( curr_node.length===0 || curr_node.is(m_rv_selector1_not_del) ) break;
			}
			$prev_c = $c;
		}
		result.tmp_candidates = $(result.tmp_candidates);
		// use last candidate item, if no exact match found ... (but only, if the "more" action was not triggered)
		if( result.ns_node===null && result.tmp_candidates.length && !result.more_triggered ) result.ns_node = result.tmp_candidates.last();
		return result;
	}

	function _keydownInResultView( evt, customSelectionChanged ) {
		var tmp = _selectAndOrGetSelectedNodeState_rv();
		var has_sel = tmp[0];
		var sel_nodes = tmp[1];
		var fri = { ns_node:null, tmp_candidates:null, more_triggered:false };
		var shiftMode = evt.shiftKey;
		var cur_node;
		var csm_tmp_nodes;
		var elem;
		if( has_sel ) {
			if( sel_nodes.hasClass('cthumbnail') ) shiftMode = false; // disable multiselect on category nodes
			var view_type = getFromSession('view_type');
			if( evt.which==13 || evt.which==32 || evt.which==77 ) {
				// SPACE, ENTER, M
				// scroll into view, if first selected node is not in visible area
				scrollElementIntoView( _xnodes2ynodes(sel_nodes), m_result_root, 0, 3 );
				window.setImmediate( function() {
					if( customSelectionChanged ) customSelectionChanged();
					else m_result_view_widget.selectionChanged(evt,true);
					if( sel_nodes && sel_nodes.length ) {
						if( evt.which==13 ) m_open_action();
						else m_toggle_ctx_toolbar_action();
					}
				} );
				return false;
			}
			switch( evt.which ) {
			case 37: // left
				cur_node = _xnodes2ynodes(sel_nodes.first());
				csm_tmp_nodes = cur_node.prevAll(m_rv_selector1_not_del).first();
				if( csm_tmp_nodes.length==0 ) csm_tmp_nodes = cur_node;
				fri.ns_node = csm_tmp_nodes.first().children(m_rv_selector2);
				break;
			case 39: // right
				cur_node = _xnodes2ynodes(sel_nodes.last());
				csm_tmp_nodes = cur_node.nextAll(m_rv_selector1_not_del).first();
				if( csm_tmp_nodes.length==0 ) {
					csm_tmp_nodes = cur_node;
					if( (elem=cur_node.nextAll('div.more-actions')).length>0 ) {
						fri.more_triggered = true;
						window.setImmediate( function() {
							elem.children('div.more').trigger('click',function(success) {
								if( success ) _keydownInResultView(evt,customSelectionChanged);
							} );
						} );
						return false;
					}
				}
				fri.ns_node = csm_tmp_nodes.first().children(m_rv_selector2);
				break;
			case 38: // up
				if( view_type==='table' )			fri = _find_result_item( evt, customSelectionChanged, sel_nodes, shiftMode, true, _fri_regular_up );
				else if( view_type==='grid' )		fri = _find_result_item( evt, customSelectionChanged, sel_nodes, shiftMode, true, _fri_irregular_up, true );
				else if( view_type==='list' )		fri = _find_result_item( evt, customSelectionChanged, sel_nodes, shiftMode, true, _fri_irregular_up, true );
				break;
			case 40: // down
				if( view_type==='table' )			fri = _find_result_item( evt, customSelectionChanged, sel_nodes, shiftMode, false, _fri_regular_down );
				else if( view_type==='grid' )		fri = _find_result_item( evt, customSelectionChanged, sel_nodes, shiftMode, false, _fri_irregular_down, true );
				else if( view_type==='list' )		fri = _find_result_item( evt, customSelectionChanged, sel_nodes, shiftMode, false, _fri_irregular_down, true );
				break;
			}
			//if( csm_tmp_nodes.length==0 ) csm_tmp_nodes = cur_node;
			// TODO: evt.shiftKey, two nodes combined !?
		}
		if( fri.more_triggered ) return false;
		// update selected states
		if( shiftMode && fri.ns_node && fri.ns_node.length && fri.ns_node.hasClass('cthumbnail') ) shiftMode = false;		// disable multiselect on category nodes
		if( shiftMode && fri.ns_node && fri.ns_node.length && fri.tmp_candidates ) fri.tmp_candidates.not('.ui-selected').addClass('ui-selected');
		//console.log(fri);
		if( fri.ns_node && fri.ns_node.length ) {
			//if( !shiftMode ) sel_nodes.filter('.ui-selected').removeClass('ui-selected');
			if( !shiftMode ) sel_nodes.removeClass('ui-selected');
			fri.ns_node.not('.ui-selected').addClass('ui-selected');
			// scroll view, if the node is not in visible area
			scrollElementIntoView( _xnodes2ynodes(fri.ns_node), m_result_root, 0, 3 );
		}
		window.setImmediate( function() {
			// update result selection ...
			if( customSelectionChanged ) customSelectionChanged();
			else m_result_view_widget.selectionChanged(evt,true);
		} );
		return false;
	}

	function _handleSelectAll( evt, customSelectionChanged ) {
		// select all
		if( _isLightboxVisible() ) {
			// in lightbox
			const lb_nodes = _get_lb_nodes();
			if( lb_nodes.length && lb_nodes.filter('.ui-selected').length ) {
				// TODO
				// NOT YET POSSIBLE (must fix _get_lb_nodes() then tooo)
				evt.preventDefault();
				return false;
			}
		}
		// in result view
		startProgress(true);
		window.setTimeout( function() {
			m_result_view_widget.loadRemainingResult( function() {
				window.setImmediate( function() {
					_get_rv_nodes('categories').filter('.ui-selected').removeClass('ui-selected');
					_get_rv_nodes('media-all').not('.ui-selected').addClass('ui-selected');
					window.setImmediate( function() {
						m_result_view_widget.updateAllNodes( function() {
							window.setImmediate( function() {
								if( customSelectionChanged ) customSelectionChanged();
								else m_result_view_widget.selectionChanged(evt,true);
								stopProgress();
							} );
						} );
					} );
				} );
			} );
		}, 3*4 );
		evt.preventDefault();
		return false;
	}

	return {
		init: function( result_root, result_view_widget, open_action_fn, toggle_ctx_toolbar_action_fn ) {
			m_result_root = result_root;
			m_result_view_widget = result_view_widget;
			m_open_action = open_action_fn || function() { };
			m_toggle_ctx_toolbar_action = toggle_ctx_toolbar_action_fn || function() { };

			$(document).on('keydown',_handleKeydown);

			/* SUPERFLUOUS NOW
			// QUIRK: the select2 adapter 'select2/selection/search' stops propagation of keydown events and triggers keypress events instead...
			// -> so we must bind directly to such events ..
			$('#sopts-content').on('mjssearchoptionsvisibility_changed.mjMMediaViewsKbdCtrl',function(sovce) {
				var nodes = MVSearch.getFocusableNodesWhichDontBubbleKeydownEvents()
									//.removeClass('mj-mvkc-handler-bound');
									.not('.mj-mvkc-handler-bound');

				console.log(['mjssearchoptionsvisibility_changed',sovce,nodes]);

				nodes.addClass('mj-mvkc-handler-bound')
					.off('keydown.mjMMediaViewsKbdCtrl')
					.on('keydown.mjMMediaViewsKbdCtrl',function(e) {
						console.log(['KEYDOWN evt on mj-mvkc-handler-bound',sovce,nodes,e]);
						//if( e.which||e.keyCode == 9 ) {
						//	if( e.which==0 ) e.which = 9; // WTF???
						if( e.which == 9 ) {
							e.preventDefault();
							return _handleKeydown(e);
						}
					} );
			} );
			*/

			// default-select nodes when result list has changed (e.g. when navigating through categories etc.)
			m_result_root.off('.mjMMediaViewsKbdCtrl').on( 'mjmediaresultviewwidgetlist_changed.mjMMediaViewsKbdCtrl', function( evt, list_data ) {
				if( MVSearch.hasFocus() ) return; // nothing to do here
				var lb_visible = _isLightboxVisible();
				var lb_nodes = lb_visible ? _get_lb_nodes() : null;
				if( lb_visible && lb_nodes.length && lb_nodes.filter('.ui-selected').length ) return; // nothing to do here
				var rv_nodes = _get_rv_nodes1();
				if( rv_nodes.length && rv_nodes.filter('.ui-selected').length ) return; // nothing to do here
				// now we know - absolutely no node is selected
				// so -> default select the first node in result view
				// but not in lightbox: if( lb_visible && lb_nodes.length ) _defaultSelectFirstNode(lb_nodes,null);
				if( rv_nodes.length===0 ) return; // nothing to do here
				_defaultSelectFirstNode(rv_nodes,m_result_root);

				// defer call to "updateSelectedNodes()" to avoid duplicate requests to "json/media/list-get" ...
				// (meanwhile MVResult probably started its own "list-get", which may include the selected node; the defered "updateSelectedNodes()" could re-use that result then)
				window.setImmediate( function() {
					// load relevant nodes ...
					m_result_view_widget.updateSelectedNodes( 2, 2, function() {
						window.setImmediate( function() {
							// trigger change ...
							m_result_view_widget.selectionChanged(evt,false);
						} );
					} );
				} );
			} );
		},

		handleUnobstructedKeydownInResultView: function( evt, customSelectionChanged ) {
			return _unobstructed_handleKeydown(evt,customSelectionChanged);
		}
		// ,benchmark: function() {
		// 	console.time('MMediaViewsKbdCtrl.benchmark');
		// 	for( var i=0; i<10; ++i ) {
		// 		_selectAndOrGetSelectedNodeState_rv();
		// 	}
		// 	console.timeEnd('MMediaViewsKbdCtrl.benchmark');
		// }
	};

}(jQuery); // namespace MMediaViewsKbdCtrl
